export default __webpack_public_path__ + "static/assignee-do-dark-0e51bcc501bbee9124abfadcbe6d8734.png";